import React from 'react';

// export const MenuSvg = (props) => (
//   <svg width={24} height={24} viewBox="0 0 24 24" focusable="false" {...props}>
//     <path d="M24 6H0V2h24v4zm0 4H0v4h24v-4zm0 8H0v4h24v-4z" fill="currentColor" />
//   </svg>
// );


export const MenuSvg = (props) => (
    <svg width={24} height={24} fillRule="evenodd" clipRule="evenodd" focusable="false" {...props}>
        <path d="M24 18v1H0v-1h24zm0-6v1H0v-1h24zm0-6v1H0V6h24z" fill="currentColor"  />
        <path d="M24 19H0v-1h24v1zm0-6H0v-1h24v1zm0-6H0V6h24v1z"  fill="currentColor" />
    </svg>
);